import React from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();

  // Function to check if a link is active
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
      <Link to="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
        <h2 className="m-0 text-secondary">
          Rev<span className="text-primary">tech</span>
        </h2>
      </Link>
      <button
        type="button"
        className="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">
          <Link
            to="/"
            className={`nav-item nav-link ${isActive("/") ? "active" : ""}`}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={`nav-item nav-link ${isActive("/about") ? "active" : ""}`}
          >
            About
          </Link>
          <Link
            to="/it-staffing"
            className={`nav-item nav-link ${isActive("/it-staffing") ? "active" : ""}`}
          >
            IT staffing
          </Link>
          <div className="nav-item dropdown">
            <Link
              to="/technology"
              className="nav-link dropdown-toggle"
             // data-bs-toggle="dropdown"
            >
              Technology
            </Link>
            <div className="dropdown-menu bg-light m-0">
              <Link to="#" className="dropdown-item">
                Data Warehousing
              </Link>
              <Link to="#" className="dropdown-item">
                Quality Assurance
              </Link>
              <Link to="#" className="dropdown-item">
                Database
              </Link>
              <Link to="#" className="dropdown-item">
                Programming
              </Link>
              <Link to="#" className="dropdown-item">
                Business Analysis
              </Link>
              <Link to="#" className="dropdown-item">
                Project Management
              </Link>
              <Link to="#" className="dropdown-item">
                ERP
              </Link>
              <Link to="#" className="dropdown-item">
                SDLC Methodologies
              </Link>
            </div>
          </div>
          <Link
            to="/client"
            className={`nav-item nav-link ${isActive("/client") ? "active" : ""}`}
          >
            Client
          </Link>
          <div className="nav-item dropdown">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              Careers
            </Link>
            <div className="dropdown-menu bg-light m-0">
              <Link to="/benefits" className="dropdown-item">
                Benefits
              </Link>
              <Link to="/referral-bonus" className="dropdown-item">
                Referral Bonus
              </Link>
            </div>
          </div>
          <Link
            to="/contact"
            className={`nav-item nav-link ${isActive("/contact") ? "active" : ""}`}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Header;
